import { render, staticRenderFns } from "./ModalFile.vue?vue&type=template&id=8b5bf792&scoped=true&"
import script from "./ModalFile.vue?vue&type=script&lang=js&"
export * from "./ModalFile.vue?vue&type=script&lang=js&"
import style0 from "./ModalFile.vue?vue&type=style&index=0&id=8b5bf792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5bf792",
  null
  
)

export default component.exports